import { isGradingCompany } from 'shared/helpers/matchers/checkCompanyType';

const samplesAllowedAvailable = companyType => companyType && !isGradingCompany(companyType);

export { samplesAllowedAvailable };
